module.exports = __webpack_public_path__ + "img/2a06e84.svg";